<template>
  <div class="container">
    <div class="item align-center">
      <span class="must">*</span>
      <span class="title">特色科室名称</span>
      <el-input
        v-model="department_name"
        placeholder="请输入10位以内汉字或字符"
        style="width: 240px"
        maxlength="10"
      ></el-input>
    </div>
    <div class="item">
      <span class="must">*</span>
      <span class="title">科室说明</span>
      <el-input
        style="width: 700px"
        type="textarea"
        :autosize="{ minRows: 7, maxRows: 10 }"
        placeholder="请输入100字以内"
        maxlength="100"
        v-model="introduction"
        show-word-limit
      ></el-input>
    </div>
    <div>
      <div class="item">
        <span class="must">*</span>
        <span class="title">科室图片</span>
        <div>
          <div style="color: #f59a23; margin-bottom: 10px">
            显示到科室主页封面
          </div>
          <div class="imgbox">
            <el-upload
              class="avatar-uploader"
              name="image"
              accept=".png,.jpeg,.jpg"
              :action="uploadUrl"
              :data="uploadExtraData"
              :headers="uploadHeaders"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
            >
              <img
                v-if="image"
                :src="image_str"
                class="avatar"
              />

              <i
                v-else
                class="el-icon-plus avatar-uploader-icon"
              ></i>
            </el-upload>
          </div>
        </div>
      </div>
    </div>
    <div
      class="flex align-center"
      style="margin-top: 40px"
    >
      <span style="color: #e93528; margin-right: 3px">*</span>
      <span style="display: inline-block; width: 100px; font-weight: 700">科室图文介绍</span>
      <span style="color: #f59a23">显示到科室详情页面</span>
    </div>
    <div style="width: 100%; height: 100%">
      <wangeditor ref="editorBox" />
    </div>
    <div style="text-align: center">
      <el-button
        type="primary"
        style="width: 120px"
        @click="saveMsg"
        :disabled="
          module_id_array[0] ? !module_id_array.includes('274') : false
        "
      >保存</el-button>
    </div>
  </div>
</template>
<script>
import constant from '../../../service/common/constant';
import clinic from '../../../api/clinic';
import wangeditor from './wangeditor';
export default {
  data() {
    return {
      department_name: '',
      introduction: '',
      image: '',
      image_str: '',
      uploadExtraData: {
        img_type: 4,
        suffix: '.jpg'
      }
    };
  },
  components: {
    wangeditor
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    admin_id() {
      return this.$store.state.login.userInfo.admin_id;
    },
    uploadUrl() {
      if (process.env.NODE_ENV == 'development') {
        // 本地开发使用 api 前缀
        return 'api/platform/upload/uploadFile';
      } else {
        return 'platform/upload/uploadFile';
      }
    },
    uploadHeaders: function () {
      return Object.assign(
        {},
        _.pick(constant.HEADERS, ['version', 'platform', 'appid']),
        {
          timestamp: Date.now(),
          token: this.$store.state.login.headerToken
        }
      );
    }
  },

  methods: {
    //上传成功
    handleAvatarSuccess(res, file, fileList) {
      if (res.code === 0) {
        //半路径
        this.image = res.data.pic;
        //绝对路径
        this.image_str = res.data.path;
      }
    },
    beforeAvatarUpload(file) {
      const supportImgTypes = ['image/jpeg', 'image/png', 'image/jpg'];
      const isSupportType = _.indexOf(supportImgTypes, file.type) !== -1;
      if (!isSupportType) {
        this.$message.error('上传图片只能是 jpg, png, jpeg 格式!');
        return false;
      }
      const suffix = file.name.substring(file.name.lastIndexOf('.'));
      this.uploadExtraData.suffix = suffix;
      this.uploadHeaders.timestamp = Date.now();
      return isSupportType;
    },
    //保存
    saveMsg() {
      if (!this.department_name) {
        this.$message.error('请填写特色科室名称');
        return false;
      }
      if (!this.introduction) {
        this.$message.error('请填写特色科室说明');
        return false;
      }
      if (!this.image) {
        this.$message.error('请上传特色科室图片');
        return false;
      }
      let content = this.$refs.editorBox.editor.txt.html();
      if (!content) {
        this.$message.error('请填写科室图文介绍');
        return false;
      }
      let data = {
        department_id: this.$route.query.department_id,
        department_name: this.department_name,
        introduction: this.introduction,
        image: this.image,
        content: this.$refs.editorBox.editor.txt.html()
      };
      clinic.saveSpecialDepartmentInfo(data).then((res) => {
        if (res.code == 0) {
          this.$message.success('保存成功');
          this.getMsg();
        }
      });
    },
    //获取详情
    getMsg() {
      let department_id = this.$route.query.department_id;
      clinic.getSpecialDepartmentInfo({ department_id }).then((res) => {
        if (res.code == 0) {
          let detail = res.data.info;
          this.department_name = detail.department_name;
          this.introduction = detail.introduction;
          this.image = detail.image;
          this.image_str = detail.image_str;
          if (detail.content) {
            this.setDesc(detail.content);
            this.content = detail.content;
          }
        }
      });
    },
    //往编辑器里插入数据
    setDesc(text) {
      this.$refs.editorBox.editor.txt.html(text);
    }
  },
  created() {
    this.getMsg();
  }
};
</script>
<style lang="scss" scoped>
.container {
  padding: 20px;
  text-align: left;
}
.item {
  display: flex;
  margin-bottom: 20px;
  .must {
    color: #e93528;
    margin-right: 3px;
  }
  .title {
    display: inline-block;
    width: 100px;
    font-weight: 700;
  }
}

.imgbox {
  width: 200px;
  height: 144px;
  box-sizing: border-box;
  background-color: #fff;
  border: solid 1px #d6d6d6;
}
.avatar-uploader .el-upload {
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader-icon {
  font-size: 32px;
  color: #8c939d;
  font-weight: 600;
  width: 200px;
  height: 144px;
  line-height: 124px;
  text-align: center;
}
.avatar {
  width: 198px;
  height: 142px;
  display: block;
}
</style>